import styled from 'styled-components';

import { fontSizes } from '@gaming1/g1-style';
import { Box } from '@gaming1/g1-ui';

export const GeolocationModalTipsBox = styled(Box)`
  text-align: center;
  font-size: ${fontSizes('md')};
`;
